import { makeApolloClient, logError } from '../util';
import { MEDIA, EVENT_MEDIA_FOLDER } from 'queries/media';

export const FETCH_MEDIA = 'FETCH_MEDIA';
export const FETCH_EVENT_MEDIA = 'FETCH_EVENT_MEDIA';
export const CREATE_MEDIA = 'CREATE_MEDIA';
export const UPDATE_MEDIA = 'UPDATE_MEDIA';
export const DELETE_MEDIA = 'DELETE_MEDIA';
export const CLEAR_MEDIA = 'CLEAR_MEDIA';
export const CLEAR_EVENT_MEDIA = 'CLEAR_EVENT_MEDIA';

const fetchEventMedia = ({ libraries, media }, from) => ({
	type: FETCH_EVENT_MEDIA,
	libraries,
	media,
	from,
});

const fetchSingleMedia = (selectedMedia, from) => ({
	type: FETCH_MEDIA,
	selectedMedia,
	from,
});

export const createMedia = (media, from) => ({
	type: CREATE_MEDIA,
	media,
	from,
});

export const updateMedia = (media, from) => ({
	type: UPDATE_MEDIA,
	media,
	from,
});

export const deleteMedia = ({ id }, from) => ({
	type: DELETE_MEDIA,
	mediaID: id,
	from,
});

export const clearEventMedia = from => ({
	type: CLEAR_EVENT_MEDIA,
	from,
});

export const clearMedia = from => ({
	type: CLEAR_MEDIA,
	from,
});

export const thunkFetchEventMedia = (
	{ event_id, offset, search_term, items_per_page },
	from
) => async (disptach, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventMediaFolder } = await client.request(EVENT_MEDIA_FOLDER, {
			event_id,
			search_term,
			offset,
			items_per_page,
		});
		disptach(fetchEventMedia(eventMediaFolder, from));
	} catch (error) {
		logError('media.actions.thunkFetchEventMedia', error);
	}
};

export const thunkFetchMedia = (id, from) => async (disptach, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { media } = await client.request(MEDIA, {
			id,
		});
		disptach(fetchSingleMedia(media, from));
	} catch (error) {
		logError('media.actions.thunkFetchMedia', error);
	}
};
